import { render } from "./TarotLine.vue?vue&type=template&id=1e5d87f6"
import script from "./TarotLine.vue?vue&type=script&lang=js"
export * from "./TarotLine.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__